import { GetterTree } from 'vuex';
import { TrainerHoursState } from './types';
import { RootState } from '../../types';

export const getters: GetterTree<TrainerHoursState, RootState> = {
  ['getTrainerHours']: (state) => state.trainerHours,
  ['getTrainerHoursIsLoading']: (state) => state.trainerHours?.isLoading,
  ['getTrainerHoursTotal']: (state) => state.trainerHours?.total,
  ['getTrainerHoursSearchParams']: (state) => state.trainerHours?.searchParams,
};
